export enum StandalonePagePath {
  error = "error",
  errorOption = "error-option",
  loading = "loading",
}
